// extracted by mini-css-extract-plugin
module.exports = {"popularSearches":"_c4e3ae99","popularSearchesCategory":"_61beeba9"};